<template>
  <div class="login-container">
    <div class="control-row p-error head" >
      {{message}}
    </div>
    <div class="control-row" >
        <InputText type="text" :placeholder="$t('message.input_username')" v-model="username" class="full-width" :class="{'p-invalid':submitted&&!usernamevalid}" />
        <div class="message p-error" v-if="(submitted&&!usernamevalid)">
          {{$t('message.username_required')}}
        </div>
    </div>
    
    <div class="control-row" >
        <Password :placeholder="$t('message.input_password')" v-model="password" class="full-width" :class="{'p-invalid':submitted&&!passwordvalid}" :feedback="false" :toggle-mask="true"/>
        <div class="message p-error" v-if="(submitted&&!passwordvalid)">
          {{$t('message.password_required')}}
        </div>
    </div>
    
    <div class="control-row" >
        <Button :label="logining?$t('message.signing_in'):$t('message.sign_in')" @click="login()" class="full-width" :loading="logining" />
    </div>   
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import axios from 'axios';

export default {
  name: 'LoginControl',
  inject: ['dialogRef'],
  components: {
    InputText,
    Password,
    Button
  },
  data(){
    return {
      message: this.$t('message.please_login'),
      qrid:null,
      usernamevalid:true,
      username:'',
      passwordvalid:true,
      password:'',
      submitted:false,
      logining:false
    }
  },
  props: {
  },
  methods:{
    login(){

      this.submitted=true;

      this.usernamevalid=(this.username.trim()!='');

      this.passwordvalid=(this.password.trim()!='');

      if(this.usernamevalid&&this.passwordvalid){

          this.logining=true;

          axios
          .post(this.$common.HOST+'/site/login.html?client=scan&qrid='+this.qrid,{username:this.username,password:this.password})
          .then(response => {

              const result=response.data;

              if(result.status==1)
              {

                this.$common.userid=result.id;

                this.$common.roles=result.roles;

                this.$common.access_token=result.token;

                this.$common.LOGIN_REQUIRED=0;

                this.dialogRef.close();

              }
              else
                this.$toast.add({severity:'error', summary: this.TITLE, detail:this.i18n.t('message.invalid_user_or_password'), life: 3000});

              this.logining=false;

          })
          .catch(() => {

            const msg=this.i18n.t('message.fail_login');
                
            this.$toast.add({severity:'error', summary: this.TITLE, detail:msg, life: 3000});

            this.logining=false;

          })        

      }

    }
  },
  created(){
    
    this.message=this.dialogRef.data.message;

    this.qrid=this.dialogRef.data.qrid;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login-container{
  height:100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:1rem 3rem;
}
.control-container:last-child{
  margin-bottom: 0px;
}
.control-row{
  margin-bottom: 1rem;
  text-align:left;
  width:100%;
}
.message{
  margin-top:5px;
}
.full-width{
  width:100%;
}

.head{
  text-align: center;
}
</style>